import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import KeyValueTooltip from 'notebook/entry-templates/SelectTemplateCollectionItemTree/KeyValueTooltip';
import {
  isSubtemplateNode,
  isTemplateNode,
  SelectTemplateCollectionItem,
} from 'notebook/entry-templates/SelectTemplateCollectionItemTree/types';
import Avatar from 'ui-library/avatar/Avatar';
import {AvatarSize, AvatarShape} from 'ui-library/avatar/AvatarConstants';

const OwnerAvatar = ({item}: {item: SelectTemplateCollectionItem}): JSX.Element => (
  <KeyValueTooltip
    keyText="Owner/Author"
    valueText={isTemplateNode(item) || isSubtemplateNode(item) ? item.creator.name : item.ownerJson.name}
  >
    <div className={css(styles.avatar)}>
      <Avatar
        entity={isTemplateNode(item) || isSubtemplateNode(item) ? item.creator : item.ownerJson}
        size={AvatarSize.XXSMALL}
        shape={AvatarShape.CIRCLE}
        showTooltip={false}
      />
    </div>
  </KeyValueTooltip>
);

const styles = StyleSheet.create({avatar: {paddingBottom: '2px'}});

export default OwnerAvatar;
